import * as React from "react";
import character from "assets/images/3d.svg";
import entry1 from "assets/images/entry1.png";
import entry2 from "assets/images/entry2.png";
import entry3 from "assets/images/entry3.png";
import entry4 from "assets/images/entry4.png";
import entry5 from "assets/images/entry5.png";
import entry1En from "assets/images/entry1-en.png";
import entry2En from "assets/images/entry2-en.png";
import entry3En from "assets/images/entry3-en.png";
import entry4En from "assets/images/entry4-en.png";
import entry5En from "assets/images/entry5-en.png";
import Video from "./Video";
import avatar1 from "assets/images/avatar1.glb";
import avatar2 from "assets/images/avatar2.glb";
import avatar3 from "assets/images/avatar3.glb";
import avatar4 from "assets/images/avatar4.glb";
import avatar5 from "assets/images/avatar5.glb";
import ModelViewer from "component/ModelViewer";

function Profile(props) {
  const { language } = props;
  const isEn = language === "en" ? true : false;
  const entries = [
    {
      image: language === "en" ? entry1En : entry1,
      character: character,
      preview3d: avatar1,
      name: isEn ? "Kotora" : "小虎",
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/01_Tora_Highres_w_logo.mp4",
    },
    {
      image: language === "en" ? entry2En : entry2,
      character: character,
      preview3d: avatar2,
      name: isEn ? "Suzu" : "すず",
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/02_Suzu_Highres_w_logo.mp4",
    },
    {
      image: language === "en" ? entry3En : entry3,
      character: character,
      preview3d: avatar3,
      name: isEn ? "Shinya" : "しんや",
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/03_Shinya_Highres_w_logo.mp4",
    },
    {
      image: language === "en" ? entry4En : entry4,
      character: character,
      preview3d: avatar4,
      name: isEn ? "Akane Naniwa" : "浪花明音　アカンネ〜",
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/04_Akane_Highres_w_logo.mp4",
    },
    {
      image: language === "en" ? entry5En : entry5,
      character: character,
      preview3d: avatar5,
      name: isEn ? "ANGEL" : "あんじ",
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/05_ANGEL_Highres_w_logo.mp4",
    },
  ];

  return (
    <>
      {entries.map((entry, index) => (
        <>
          <div className="flex flex-col pb-10 max-md:pr-5">
            <div
              id={entry?.name}
              className="grid z-10 gap-0 mt-0 max-md:flex-wrap max-md:mt-0 max-md:max-w-full"
            >
              <main
                className="max-md:max-w-full m-auto relative entry"
                style={{
                  backgroundImage: `url(${entry?.image})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                  width: "100%",
                  height: 720,
                  display: "table",
                }}
              >
                <div className="wrapper">
                  <div className="ratio">
                    <div className="arrow">
                      <div className="arrow-wrapper">
                        <div className="arrow-team">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                    <div className={`${index === 0 ? 'model-3d': 'model-3ds'}`}>
                      <ModelViewer
                        src={entry?.preview3d}
                        width={"100%"}
                        height={"100%"}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="preview-wrapper">
                  <ModelViewer
                    src={entry?.preview3d}
                    width={"100%"}
                    height={"100%"}
                  />
                </div>
                <div className="arrow-wrapper left-48 -bottom-32 absolute">
                  <div className="arrow-team">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div> */}
              </main>
            </div>
          </div>
          <Video video={entry.video} lang={language} width="600px" />
        </>
      ))}
    </>
  );
}

export default Profile;
